<template>
  <div class="obj-major-info-content perf-info">
    <div class="title-bar">
      <span class="title mr-r10">성능정보</span>
      <span class="sub-label">최근12시간</span>
    </div>
    <div class="chart-wrapper" v-if="showChart" style="height: 130px;">
      <div :class="['perf-chart-wrapper', chartCls]" style="height: 100%;" v-for="(rsc, idx) in chartRsc" :key="idx">
        <w-common-chart style="height: 84px; width: 84px;" :ref="chartRef(rsc)" :chart-type="'PIE'"/>
        <div class="perf-label">
          <p><label :title="label(rsc)">{{ label(rsc) }}</label></p>
        </div>
      </div>
    </div>
    <div class="empty-text" v-else >
      설정된 성능자원이 없습니다.
    </div>
  </div>
</template>

<script>
import WCommonChart from '@/views/topologymap/components/major-info/components/CommonChart';
import { isEmpty } from 'lodash';

export default {
  name: 'WOtherObjectPerfInfoView',
  components: {
    WCommonChart,
  },
  props: {
    chartData: {
      type: Object,
      default: () => {},
    },
    chartRsc: {
      type: Array,
      default: () => ([
        { rsctypeName: '', rscName: '' },
      ]),
    },
    idx: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      perfInfo: [],
      objDefineId: '',
    };
  },
  computed: {
    /**
     * 차트 라벨
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    label() {
      return (rsc) => {
        let label = '';
        if (!isEmpty(rsc)) {
          label = `${rsc.rsctypeName} ${rsc.rscName}`;
        }
        return label;
      };
    },
    /**
     * 차트 ref
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    chartRef() {
      return (rsc) => {
        let ref = '';
        if (!isEmpty(rsc)) {
          ref = `${rsc.rsctypeId}.${rsc.rscId}`;
        }
        return ref;
      };
    },
    /**
     * 차트 class
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    chartCls() {
      let cls = '';
      if (!isEmpty(this.chartRsc)) {
        switch (this.chartRsc.length) {
          case 1:
            cls = 'one-item';
            break;
          case 2:
            cls = 'two-item';
            break;
          case 3:
            cls = 'three-item';
            break;
          default:
            cls = 'one-item';
        }
      } else {
        cls = 'one-item';
      }
      return cls;
    },
    /**
     * 사용자정의 자원이 없을 경우 차트 표현 여부
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    showChart() {
      return !isEmpty(this.chartRsc);
    },
  },
  methods: {
    /**
     * 데이터 셋팅
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} data [description]
     */
    setData(data) {
      this.perfInfo = data;
      data.forEach((item) => {
        if (!isEmpty(item[0].rscInfo)) {
          const chartCmp = this.$refs[this.chartRef(item[0].rscInfo)][0];
          chartCmp.setData(item);
        }
      });
    },
    /**
     * 데이터 초기화
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    initData() {
      this.perfInfo = [];
      this.objDefineId = '';
      this.rscNameList = [];
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/OtherObjectPerfInfoView.vue